import { Address } from '@/types/address/addressType'
import { Translator } from '../../types/ApiResponseTypes'
import { AddressResponse, isAddressResponse } from '@/types/address/addressReponse'

class AddressResponseTranslator implements Translator<Address> {
  convert(response: any): Address | Address[] {
    if (isAddressResponse(response)) {
      return this.convertToAddressModel(response)
    }
    return []
  }

  convertToAddressModel(response: AddressResponse): Address {
    const pre = response.prequal
    const na = 'N/A' // Or import a translation helper if available globally

    return {
      status: response.STATUS,
      error: (response as any).error,
      city: pre.City,
      zipcode: pre.ZipCode,
      street: pre.Street,
      number: pre.HouseNumber,
      box: pre.Bus,
      VDSLStatus: pre.VDSLStatus || 'NOK',
      FiberStatus: pre.FiberStatus || 'NOK',

      // Using Optional Chaining (?.) and Nullish Coalescing (??)
      vdsl: {
        maxspeed: pre.VDSL?.MaxVDSLSpeed ?? na,
        maxdownloadspeed: pre.VDSL?.MaxVDSLDownloadSpeed ?? na,
        maxuploadspeed: pre.VDSL?.MaxVDSLUploadSpeed ?? na,
        speeds: {
          maxdownloadspeed: pre.VDSL?.speeds.MaxVDSLDownloadSpeed ?? na,
          maxuploadspeed: pre.VDSL?.speeds.MaxVDSLUploadSpeed ?? na,
        },
      },
      fiber: {
        maxspeed: pre.FIBER?.MaxFIBERSpeed ?? na,
        maxdownloadspeed: pre.FIBER?.MaxFIBERDownloadSpeed ?? na,
        maxuploadspeed: pre.FIBER?.MaxFIBERUploadSpeed ?? na,
      },
    }
  }
}
export default new AddressResponseTranslator()
